module.exports = __webpack_public_path__ + "static/media/Carleton.672fb68b.svg";